import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useRequestAuthentication } from '../../../../utils';
import { addLikeForBlogOrQuestion, IAddLikeForBlogOrQuestion } from '../../../../actions/post';
import { TThunkDispatch } from '../../../../types/redux';

export function useLikes() {
  const dispatch = useDispatch<TThunkDispatch>();
  const checkAuth = useRequestAuthentication();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Отправляет лайк/дизлайк на бэк или отправляет на авторизацию
   */
  const handleClick = useCallback(
    async ({ postId, postType, likeType }: IAddLikeForBlogOrQuestion) => {
      setIsLoading(true);

      if (checkAuth()) {
        await dispatch(
          addLikeForBlogOrQuestion({
            postId,
            postType,
            likeType,
          }),
        );
      }

      setIsLoading(false);
    },
    [checkAuth, dispatch],
  );

  return {
    handleLikeClick: handleClick,
    isLikesLoading: isLoading,
  };
}
